import React from 'react';
import { createRoot } from 'react-dom/client';
import { SibilusRoutes } from './Routes';
import { BrowserRouter } from 'react-router-dom';
import { TraksProvider } from './traks';
import MeContext, { useMe } from 'MeContext';
import { APIGet } from 'API';

import './css/sibilus.css';
import DashboardContext, { useDashboardContext } from 'contexts/dashboardContext';
import WhistlesContext, { useWhistles } from 'contexts/whistlesContext';
import { CURRENT_LANG } from './config';

const container = document.getElementById('app_root');
APIGet('whoami')
  .then((whoami) => {
    const emptyBody = Object.keys(whoami.data).length === 0;
    if (!emptyBody) {
      whoami = whoami.data;
    } else {
      whoami = null;
    }
    const App = (props) => {
      const lang = CURRENT_LANG
      return (
        <TraksProvider lang={lang}>
          <MeContext.Provider value={useMe(whoami)}>
            <WhistlesContext.Provider value={useWhistles()}>
              <DashboardContext.Provider value={useDashboardContext(whoami)}>
                <BrowserRouter>
                  <SibilusRoutes />
                </BrowserRouter>
              </DashboardContext.Provider>
            </WhistlesContext.Provider>
          </MeContext.Provider>
        </TraksProvider>
      );
    };

    const root = createRoot(container); // createRoot(container!) if you use TypeScript

    root.render(
      <App tab="home" />
    );
  })
  .catch((err) => {
    console.log(err)
    const App = (props) => {
      const lang = CURRENT_LANG
      return (
        <TraksProvider lang={lang}>
          <MeContext.Provider value={useMe(null)}>
            <WhistlesContext.Provider value={useWhistles()}>
              <DashboardContext.Provider value={useDashboardContext(null)}>
                <BrowserRouter>
                  <SibilusRoutes />
                </BrowserRouter>
              </DashboardContext.Provider>
            </WhistlesContext.Provider>
          </MeContext.Provider>
        </TraksProvider>
      );
    };

    const root = createRoot(container); // createRoot(container!) if you use TypeScript

    root.render(
      <App tab="home" />
    );
  });
